export default __webpack_public_path__ + "static/media/thrash2.79600c17.svg";